import React, { useState, useEffect, useContext } from 'react';
import AvatarShop from './AvatarShop';
import Wardrobe from './Wardrobe';
import AvatarPreview from './AvatarPreview';
import AvatarBuilder from '../../components/_AvatarBuilder/ItemBuilder';
import AuthContext from '../../context/AuthContext';
import './Avatars.css';

const Avatars = () => {
    const [activeTab, setActiveTab] = useState(() => localStorage.getItem('avatarTab') || 'shop');
    const [shopCount, setShopCount] = useState(0);
    const [wardrobeCount, setWardrobeCount] = useState(0);
    const { user } = useContext(AuthContext);

    useEffect(() => {
        localStorage.setItem('avatarTab', activeTab);
    }, [activeTab]);

    useEffect(() => {
        fetch('/api/avatars/shop')
            .then(res => res.json())
            .then(data => {
                const count = Object.values(data).flat().length;
                setShopCount(count);
            });

        fetch('/api/avatars/me')
            .then(res => res.json())
            .then(data => {
                setWardrobeCount(data.wardrobe?.length || 0);
            });
    }, []);

    const renderTabContent = () => {
        switch (activeTab) {
            case 'shop':
                return <AvatarShop />;
            case 'wardrobe':
                return <Wardrobe />;
            case 'customise':
                return <AvatarPreview />;
            case 'builder':
                return <AvatarBuilder />;
            default:
                return null;
        }
    };

    return (
        <div className="avatars-container">
            <h1 className="avatars-title">🎨 Avatars</h1>

            <div className="avatar-tabs" role="tablist" aria-label="Avatar options">
                <button
                    onClick={() => setActiveTab('shop')}
                    className={activeTab === 'shop' ? 'active' : ''}
                    role="tab"
                    aria-selected={activeTab === 'shop'}
                >
                    Shop {shopCount > 0 && <span className="badge">{shopCount}</span>}
                </button>
                <button
                    onClick={() => setActiveTab('wardrobe')}
                    className={activeTab === 'wardrobe' ? 'active' : ''}
                    role="tab"
                    aria-selected={activeTab === 'wardrobe'}
                >
                    Wardrobe {wardrobeCount > 0 && <span className="badge">{wardrobeCount}</span>}
                </button>
                <button
                    onClick={() => setActiveTab('customise')}
                    className={activeTab === 'customise' ? 'active' : ''}
                    role="tab"
                    aria-selected={activeTab === 'customise'}
                >
                    Customise
                </button>
                {['creator', 'admin', 'owner'].includes(user?.role) && (
                    <button
                        onClick={() => setActiveTab('builder')}
                        className={activeTab === 'builder' ? 'active' : ''}
                        role="tab"
                        aria-selected={activeTab === 'builder'}
                    >
                        Item Builder
                    </button>
                )}
            </div>

            <div className="avatar-tab-content">
                {renderTabContent()}
            </div>
        </div>
    );
};

export default Avatars;
